import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthState } from "/app/src/contexts/authentication";
import Box from "/app/src/components/generic/components/box";

export default function SettingsMenu({
  appSettingsCount,
}: {
  appSettingsCount: number;
}) {
  const { t } = useTranslation();
  const { user } = useAuthState();

  return (
    <div className="settingsMenu sideMenu">
      <Box>
        <ul>
          <li>
            <NavLink end to="/settings">
              {t("translation:general")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/settings/kardex">{t("translation:kardex")}</NavLink>
          </li>
          <li>
            <NavLink to="/settings/connections">
              {t("translation:connections")}
            </NavLink>
          </li>
          {user?.username === "ItemPathAdmin" && (
            <li>
              <NavLink to="/settings/report_column_types">
                {t("translation:custom_columns")}
              </NavLink>
            </li>
          )}
          {appSettingsCount > 0 && (
            <li>
              <NavLink to="/settings/apps">{t("translation:apps")}</NavLink>
            </li>
          )}
        </ul>
      </Box>
    </div>
  );
}
